import { Log } from '../../../../../log';
export class Subject {
    constructor(onSubscribe, onUnsubscribe) {
        this.onSubscribe = onSubscribe;
        this.onUnsubscribe = onUnsubscribe;
        this.log = Log.channel('Subject');
        this.observers = [];
    }
    get hasObservers() {
        return this.observers.length > 0;
    }
    get numObservers() {
        return this.observers.length;
    }
    complete() {
        var _a;
        const tmpObservers = this.observers; // copy reference so observers can unsubscribe in loop
        for (const observer of tmpObservers) {
            try {
                (_a = observer.complete) === null || _a === void 0 ? void 0 : _a.call(observer);
            }
            catch (error) {
                this.log.error(error);
            }
        }
        this.observers.length = 0;
    }
    error(error) {
        var _a;
        const tmpObservers = this.observers; // copy reference so observers can unsubscribe in loop
        for (const observer of tmpObservers) {
            try {
                (_a = observer.error) === null || _a === void 0 ? void 0 : _a.call(observer, error);
            }
            catch (error) {
                this.log.error(error);
            }
        }
        this.observers.length = 0;
    }
    next(value) {
        var _a;
        const tmpObservers = this.observers; // copy reference so observers can unsubscribe in loop
        for (const observer of tmpObservers) {
            try {
                (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value);
            }
            catch (error) {
                this.log.error(error);
            }
        }
    }
    subscribe(observerOrNext, error, complete) {
        var _a;
        const observer = typeof observerOrNext === 'object'
            ? observerOrNext
            : {
                next: observerOrNext,
                error,
                complete,
            };
        this.observers.push(observer);
        (_a = this.onSubscribe) === null || _a === void 0 ? void 0 : _a.call(this, observer);
        return { unsubscribe: () => this.unsubscribe(observer) };
    }
    unsubscribe(observer) {
        // Create new copy of observers array when unsubscribing. This makes it safe for observers
        // to unsubscribe in notification loops.
        var _a;
        this.observers = this.observers.filter((obs) => {
            return observer !== obs;
        });
        (_a = this.onUnsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}
export class BehaviorSubject extends Subject {
    constructor(initialValue, onSubscribe, onUnsubscribe) {
        super(observer => {
            var _a;
            try {
                (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, this._value);
            }
            catch (error) {
                this.log.error(error);
            }
            onSubscribe === null || onSubscribe === void 0 ? void 0 : onSubscribe(observer);
        }, onUnsubscribe);
        this._value = initialValue;
    }
    get value() {
        return this._value;
    }
    next(value) {
        this._value = value;
        super.next(value);
    }
}
